import { Component, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { TooltipPosition, MatTooltipModule } from '@angular/material/tooltip';
import { MatStepperModule, MatStepper } from '@angular/material/stepper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormArray, FormGroup, Validators, ValidatorFn, FormsModule, FormBuilder, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { BackendV4Service } from '../service/backend-v4.service';
import { MatInputModule } from '@angular/material/input';
import { QRCodeModule } from 'angularx-qrcode';


@Component({
  selector: 'app-new-school',
  standalone: true,
  imports: [QRCodeModule, MatProgressSpinnerModule, MatButtonModule, MatIconModule, MatInputModule, MatCardModule, MatStepperModule, MatFormFieldModule, FormsModule, ReactiveFormsModule],
  templateUrl: './new-school.component.html',
  styleUrl: './new-school.component.scss'
})
export class NewSchoolComponent {

  constructor(private router: Router) {
    this.newStateMachine(0)
  }

  @ViewChild(MatStepper) stepper!: MatStepper;
  private formBuilder = inject(FormBuilder);
  private backEndHandler = inject(BackendV4Service)
  private snackBar = inject(MatSnackBar);
  readonly credentials = this.backEndHandler.getLoginCredentials()
  readonly userData = this.backEndHandler.getUserData()
  readonly siteTemplate = this.backEndHandler.getWwwTemplate()
  public countDownMinutes = 0
  public countDownSeconds = 0
  private timerHandle: any = null
  private timerCounter = 0
  public fqdn = ''
  public isValidating = false
  public loginString: string = ''
  readonly ONE_SECOND = (1 * 1000)
  readonly ONE_MINUTE = (1 * 60 * this.ONE_SECOND)
  readonly ONE_HOUR = (1 * 60 * this.ONE_MINUTE)
  readonly ONE_DAY = (1 * 24 * this.ONE_HOUR)

  registerFormGroup = this.formBuilder.group({
    username: ['', Validators.required],
  });
  verificationFormGroup = this.formBuilder.group({
    otp: ['', [Validators.required, Validators.maxLength(6), Validators.minLength(6)]],
    username: ['', [Validators.required]]
  });
  personalFormGroup = this.formBuilder.group({
    firstName: ['', Validators.required],
    middleName: [''],
    lastName: ['', Validators.required],
    phoneNumber: [''],
    email: [''],
    username: ['', [Validators.required, Validators.minLength(6)]],
    schoolId: [null],
    rbac: [["SuperSiteAdmin"]],
    password: ""
  });

  resend() {
    if (this.registerFormGroup.value.username) {
      this.backEndHandler.getOneTimePasswordAPI(this.registerFormGroup.value.username)
      this.verificationFormGroup.patchValue({ username: this.registerFormGroup.value.username, otp: '' })
      this.personalFormGroup.patchValue({ username: this.registerFormGroup.value.username })
      this.backEndHandler.getOneTimePasswordAPI(this.registerFormGroup.value.username)
    }
  }

  newStateMachine(step: number) {
    switch (step) {
      case 0: {
        this.registerFormGroup.reset()
        clearInterval(this.timerHandle)
        break;
      }
      case 1: {
        if (this.registerFormGroup.value.username) {
          this.isValidating = false
          this.backEndHandler.getOneTimePasswordAPI(this.registerFormGroup.value.username)
          this.verificationFormGroup.patchValue({ username: this.registerFormGroup.value.username, otp: '' })
          this.stepper.next()
          clearInterval(this.timerHandle)
          this.timerCounter = 2 * this.ONE_MINUTE
          this.timerHandle = setInterval(() => {
            if (this.timerCounter) {
              this.timerCounter -= this.ONE_SECOND
              this.countDownMinutes = Math.floor(this.timerCounter / this.ONE_MINUTE)
              this.countDownSeconds = Math.floor((this.timerCounter - (this.countDownMinutes * this.ONE_MINUTE)) / this.ONE_SECOND)
            } else {
              clearInterval(this.timerHandle)
              this.registerFormGroup.reset()
              this.stepper.previous()
            }
          }, 1000)
        }
        break;
      }
      case 2: {
        const loginCredentials = this.verificationFormGroup.value as { username: string, otp: string }
        this.backEndHandler.loginWithOneTimePasswordAPI(loginCredentials.username, loginCredentials.otp)
        clearInterval(this.timerHandle)
        this.isValidating = true
        this.timerCounter = 10 * this.ONE_SECOND
        this.timerHandle = setInterval(() => {
          if (this.timerCounter) {
            this.timerCounter -= this.ONE_SECOND
            const auth: any = this.credentials()
            if (auth.authKey) {
              this.isValidating = false
              this.personalFormGroup.patchValue({ username: loginCredentials.username, password: loginCredentials.otp })
              clearInterval(this.timerHandle)
              this
              this.stepper.next()
            }
          } else {
            clearInterval(this.timerHandle)
            this.verificationFormGroup.reset()
            this.personalFormGroup.reset()
            this.stepper.previous()
            this.newStateMachine(1)
          }
        }, 1000)
        break;
      }
      case 3: {
        if (this.siteTemplate()) {
          this.newStateMachine(0)
          this.stepper.previous()
          this.snackBar.open("This site already exist, login with your credentials.")
        } else {
          if (this.personalFormGroup.valid) {
            this.fqdn = this.backEndHandler.getFQDN()
            this.backEndHandler.newUserAPI({ ...this.personalFormGroup.value })
            this.stepper.next()
            this.newStateMachine(4)
            this.loginString = "https://" + this.fqdn + "/login/?u=" + this.personalFormGroup.value.username + "&p=" + this.personalFormGroup.value.password
          }
        }
        break;
      }
      case 4: {
        this.timerCounter = 20 * this.ONE_SECOND
        this.timerHandle = setInterval(() => {
          if (this.timerCounter) {
            this.timerCounter -= this.ONE_SECOND
          } else {
            clearInterval(this.timerHandle)
            const fqdn = this.backEndHandler.getFQDN()
            window.location.href = 'https://' + fqdn + '/sitebuilder/';
          }
        }, this.ONE_SECOND)
        break;
      }
    }
  }
}